(() => {
  'use strict';
  if (window.TherapressV2) { window.TherapressV2.init(document); return; }
  const states = new WeakMap();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(context) {
    const roots = [...context.querySelectorAll('[data-tp-root]')];
    if (context.matches?.('[data-tp-root]')) roots.unshift(context);
    roots.forEach(root => {
      if (states.has(root)) return;
      const state = { timer: null, visible: false, mode: 0, step: 0, paused: reduced.matches };
      states.set(root, state);
      const tabs = [...root.querySelectorAll('[data-benefit]')];
      const panels = [...root.querySelectorAll('[data-benefit-panel]')];
      state.showBenefit = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => panel.hidden = panel.dataset.benefitPanel !== tab.dataset.benefit);
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => state.showBenefit(tab));
        tab.addEventListener('keydown', e => {
          const next = {ArrowRight:(index + 1) % tabs.length, ArrowLeft:(index + tabs.length - 1) % tabs.length, Home:0, End:tabs.length - 1}[e.key];
          if (next !== undefined) { e.preventDefault(); state.showBenefit(tabs[next], true); }
        });
      });
      if (tabs.length) { root.querySelector('.benefit-tabs').dataset.enhanced = ''; state.showBenefit(tabs[0]); }

      const zoneTabs = [...root.querySelectorAll('[data-zone-tab]')];
      const zonePanels = [...root.querySelectorAll('[data-zone-panel]')];
      if (zoneTabs.length) {
        const mobile = window.matchMedia('(max-width: 800px)');
        const zoneNav = root.querySelector('.zone-tabs');
        let selectedZone = zoneTabs.find(tab => tab.dataset.zoneType === 'item_0') || zoneTabs[0];
        state.showZone = (tab, focus = false) => {
          selectedZone = tab;
          zoneNav.hidden = !mobile.matches;
          zoneTabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          zonePanels.forEach(panel => {
            panel.hidden = mobile.matches && panel.dataset.zonePanel !== tab.dataset.zoneTab;
            if (mobile.matches) {
              panel.setAttribute('role', 'tabpanel');
              panel.setAttribute('aria-labelledby', zoneTabs.find(item => item.dataset.zoneTab === panel.dataset.zonePanel).id);
              panel.tabIndex = 0;
            } else {
              panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); panel.removeAttribute('tabindex');
            }
          });
          if (focus) tab.focus();
        };
        zoneTabs.forEach((tab, index) => {
          tab.addEventListener('click', () => state.showZone(tab));
          tab.addEventListener('keydown', event => {
            const next = {ArrowRight:(index + 1) % zoneTabs.length, ArrowLeft:(index + zoneTabs.length - 1) % zoneTabs.length, Home:0, End:zoneTabs.length - 1}[event.key];
            if (next !== undefined) { event.preventDefault(); state.showZone(zoneTabs[next], true); }
          });
        });
        const syncZones = () => state.showZone(selectedZone);
        mobile.addEventListener('change', syncZones);
        state.cleanupZones = () => mobile.removeEventListener('change', syncZones);
        syncZones();
      }

      const modes = [...root.querySelectorAll('[data-mode]')];
      const chambers = [...root.querySelectorAll('.chamber')];
      const modePanels = [...root.querySelectorAll('[data-mode-panel]')];
      const pause = root.querySelector('[data-pause]');
      const draw = () => {
        // Recuperación: inflado acumulativo 1 → 1+2 → 1+2+3 → 1+2+3+4,
        // seguido de una fase completa de descarga antes de repetir el ciclo.
        const recoveryStep = state.step % 5;
        chambers.forEach((chamber, n) => {
          const active = state.mode === 0 ? n === state.step % 4
            : state.mode === 1 ? recoveryStep < 4 && n <= recoveryStep
            : Math.floor(n / 2) === state.step % 2;
          chamber.classList.toggle('active', active);
        });
        state.step++;
      };
      state.syncTimer = () => {
        clearInterval(state.timer); state.timer = null;
        if (chambers.length && state.visible && !state.paused && !document.hidden) state.timer = setInterval(draw, 1100);
        if (pause) { pause.setAttribute('aria-pressed', String(state.paused)); pause.textContent = state.paused ? 'Reanudar animación' : 'Pausar animación'; }
      };
      state.selectMode = value => {
        state.mode = Number(value); state.step = 0;
        modes.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.mode) === state.mode)));
        modePanels.forEach(panel => panel.hidden = Number(panel.dataset.modePanel) !== state.mode);
        draw();
      };
      modes.forEach(button => button.addEventListener('click', () => state.selectMode(button.dataset.mode)));
      pause?.addEventListener('click', () => { state.paused = !state.paused; state.syncTimer(); });
      if (modes.length) {
        state.selectMode(modes[0].dataset.mode);
        state.observer = new IntersectionObserver(([entry]) => { state.visible = entry.isIntersecting; state.syncTimer(); });
        state.observer.observe(root); state.syncTimer();
      }
      const compare = root.querySelector('.cmp-section');
      if (compare) {
        compare.dataset.enhanced = ''; root.querySelector('.cmp-switch').dataset.enhanced = '';
        const buttons = [...root.querySelectorAll('[data-compare-model]')];
        buttons.forEach(button => button.addEventListener('click', () => {
          compare.dataset.compare = button.dataset.compareModel;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        }));
      }
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-select-mode]');
    if (link && link.closest('[data-tp-root]')) {
      const button = document.querySelector('[data-tp-root] [data-mode="' + Number(link.dataset.selectMode) + '"]');
      button?.click();
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tp-root]').forEach(root => {
      const state = states.get(root); if (!state) return;
      clearInterval(state.timer); state.observer?.disconnect(); state.cleanupZones?.(); states.delete(root);
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const item = document.querySelector('[data-block-id="' + CSS.escape(event.detail.blockId) + '"]');
    if (!item) return;
    const root = item.closest('[data-tp-root]'); const state = states.get(root);
    if (item.dataset.zonePanel) state?.showZone(root.querySelector('[data-zone-tab="' + item.dataset.zonePanel + '"]'));
    if (item.dataset.benefitPanel) state.showBenefit(root.querySelector('[data-benefit="' + item.dataset.benefitPanel + '"]'));
    if (item.dataset.modePanel) state.selectMode(item.dataset.modePanel);
    if (item.tagName === 'DETAILS') item.open = true;
  });
  document.addEventListener('visibilitychange', () => document.querySelectorAll('[data-tp-root]').forEach(root => states.get(root)?.syncTimer()));
  reduced.addEventListener('change', () => document.querySelectorAll('[data-tp-root]').forEach(root => {
    const state = states.get(root); if (state) { state.paused = reduced.matches; state.syncTimer(); }
  }));
  window.TherapressV2 = { init };
  init(document);
})();
